// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2y7vL","badges":"styles_badges__2u3oD"};